import { Component, ViewEncapsulation } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { getCurrentUserIsSystemUser } from 'src/app/authentication/state/authentication.selector';
import { extensionTypeOptionActions } from 'src/app/common-components/entity-select/extension-type/state/extension-type-option.actions';
import { extensionTypeOptionSelectors } from 'src/app/common-components/entity-select/extension-type/state/extension-type-option.reducer';
import { Register } from 'src/app/common-components/register/models/register';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { getExtensionPrivileges, getPhonePrivileges } from 'src/app/privileges/privileges.selector';
import { PhonePrivileges } from '../../phones/models/phone-privileges';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { getShowExtensionRegisterPopupUserPreference } from 'src/app/store/user-preferences/user-preferences.selectors';
import { ExtensionPrivileges } from '../../extension-details/models/extension-privileges';
import { ExtensionRegisterOptions } from '../models/extension-register-options';
import { ExtensionRegisterListItem } from '../models/extension-register-results.model';
import { ExtensionTypeOption } from '../models/extension-type-option.interface';
import { ExtensionsFilterOption } from '../models/extensions-filter-option';
import * as ExtensionRegisterActions from '../state/extension-register.actions';
import {
   changeSipUserPasswords,
   extensionRegisterAdapterActions,
   extensionRegisterInitialFilter,
} from '../state/extension-register.actions';
import * as extensionRegisterReducer from '../state/extension-register.reducer';
import { AppConfigService } from 'src/app/app-config/app-config-service';
@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-extension-register',
    styleUrls: ['./extension-register.component.scss'],
    templateUrl: './extension-register.component.html',
    standalone: false
})
export class ExtensionRegisterComponent extends Register<
   ExtensionRegisterListItem,
   ExtensionRegisterOptions,
   OrderingOption
> {
   entityName = 'Extension';

   columns: string[] = [
      'name',
      'number',
      'type',
      'isConnected',
      'lastProvisionedDate',
      'defaultPhoneNumber',
      'extensionsActionsMenu',
   ];

   accountId: number | null;

   extensionPrivileges$: Observable<ExtensionPrivileges>;

   phonePrivileges$: Observable<PhonePrivileges>;

   createExtensionTypeOptions$: Observable<ExtensionTypeOption[]>;

   isSystemUser$: Observable<boolean>;

   showExtensionRegisterPopup$: Observable<boolean>;

   constructor(public store: Store, private appConfigService: AppConfigService) {
      super(store, extensionRegisterReducer.selectors, extensionRegisterAdapterActions);
      this.store.dispatch(extensionTypeOptionActions.load({}));
      this.createExtensionTypeOptions$ = this.store.pipe(select(extensionTypeOptionSelectors.selectFilteredItems));
      this.isSystemUser$ = this.store.pipe(select(getCurrentUserIsSystemUser));
      this.extensionPrivileges$ = store.pipe(select(getExtensionPrivileges));
      this.phonePrivileges$ = store.pipe(select(getPhonePrivileges));
      this.showExtensionRegisterPopup$ = this.store.pipe(
         select(getShowExtensionRegisterPopupUserPreference),
         map((isTooltipsShown) => isTooltipsShown ?? true)
      );
      store
         .select(getSelectedAccountId)
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            }),
            map((accountId: number) => {
               const filters: ExtensionsFilterOption[] = [
                  {
                     field: 'AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: accountId,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters) => {
            this.store.dispatch(extensionRegisterInitialFilter({ filters }));
         });
   }

   onCreateExtensionTypeSelected(extensionTypeOption: ExtensionTypeOption): void {
      this.store.dispatch(ExtensionRegisterActions.createExtension({ createExtensionTypeOption: extensionTypeOption }));
   }

   onResetHackedAndFraud(extension: ExtensionRegisterListItem) {
      const hackedAndFraudSipUserIds = extension.hackedAndFraudSipUserIds;

      if (
         hackedAndFraudSipUserIds !== null &&
         hackedAndFraudSipUserIds !== undefined &&
         hackedAndFraudSipUserIds.length > 0
      ) {
         this.store.dispatch(changeSipUserPasswords({ sipUserIds: hackedAndFraudSipUserIds }));
      }
   }
}
